export default {"src":"/_next/static/media/sort.b594dbd6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};